interface IYesNoProps {
  value: boolean
}

const YesNo = (props: IYesNoProps) => {
  const value = props.value ? "Igen" : "Nem"

  return <>{value}</>
}

export default YesNo
